import { render, staticRenderFns } from "./ChatWidgetPreview.vue?vue&type=template&id=83392d22"
import script from "./ChatWidgetPreview.vue?vue&type=script&lang=js"
export * from "./ChatWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports